<template>
  <div>
    <div class="primary--text">{{ $t('select_beacon') }}</div>
    <v-layout wrap>
      <v-flex xs8>
        <multiselect
          id="ajax"
          v-model="filterBeacon"
          class="mb-2"
          :options="beaconBranchOptions"
          :show-no-results="true"
          :placeholder="$t('Beacon')"
          label="name"
          track-by="beacon_id"
        >
        </multiselect>
      </v-flex>
      <v-flex xs4 class="text-sm-right text-xs-right">
        <v-btn
          outline
          color="primary"
          :disabled="filterItems.length == 0"
          @click="handleExportXlsx"
        >
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="filterItems"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
    >
      <template #items="props">
        <td>{{ props.item.beacon_id }}</td>
        <td>{{ props.item.beacon_name || '-' }}</td>
        <td class="text-xs-center">{{ props.item.totalUsers }}</td>
        <td class="text-xs-center">{{ props.item.totalFriend }}</td>
        <td class="text-xs-center">{{ props.item.totalNonFriend }}</td>
        <td class="text-xs-center">{{ props.item.totalMessages }}</td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center">{{ $t('No data') }}</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'

export default {
  components: {
    Multiselect
  },

  props: ['value'],
  data: function () {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      filterBeacon: null,
      items: [],
      headers: [
        { text: 'Beacon ID', value: 'beacon_id' },
        { text: this.$t('name'), value: 'beacon_name' },
        { text: this.$t('total_user_receive_message'), value: 'totalUsers' },
        { text: 'Line Friend', value: 'totalFriend' },
        { text: 'Non-Line Friend', value: 'totalNonFriend' },
        { text: this.$t('total messages'), value: 'totalMessages' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: el.name }
        })
      }

      return options
    },
    filterItems() {
      const tempData = this.items.data || {}
      const items = []

      if (Object.keys(tempData).length > 0) {
        if (this.filterBeacon) {
          const filterBeaconId = this.filterBeacon.beacon_id
          let tempObj = {
            beacon_id: filterBeaconId,
            ...tempData[filterBeaconId]
          }
          items.push(tempObj)
        } else {
          Object.keys(tempData).forEach((key) => {
            let tempObj = {
              beacon_id: key,
              ...tempData[key]
            }
            items.push(tempObj)
          })
        }
      }
      return items
    }
  },
  watch: {
    value: {
      handler() {
        this.items = this.value
      },
      deep: true
    }
  },
  mounted() {
    this.items = this.value
  },
  methods: {
    transformExportData() {
      try {
        const tempData = this.filterItems

        let sumTotalUsers = 0
        let sumTotalFriend = 0
        let sumTotalNonFriend = 0
        let sumTotalMessages = 0

        tempData.map((item) => {
          sumTotalUsers += item.totalUsers
          sumTotalFriend += item.totalFriend
          sumTotalNonFriend += item.totalNonFriend
          sumTotalMessages += item.totalMessages
        })

        let data = {
          data: tempData,
          total: { sumTotalUsers, sumTotalFriend, sumTotalNonFriend, sumTotalMessages }
        }

        return data
      } catch (error) {
        console.error(error)
      }
    },
    handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const { data, total } = vm.transformExportData()

        if (data == null) return
        const requests = data.map((el) => {
          return {
            beacon_id: el.beacon_id,
            beacon_name: el.beacon_name,
            totalUsers: el.totalUsers,
            totalFriend: el.totalFriend,
            totalNonFriend: el.totalNonFriend,
            totalMessages: el.totalMessages
          }
        })

        requests.push({
          beacon_id: '',
          beacon_name: '',
          totalUsers: total.sumTotalUsers,
          totalFriend: total.sumTotalFriend,
          totalNonFriend: total.sumTotalNonFriend,
          totalMessages: total.sumTotalMessages
        })

        const heading = [
          [
            'Beacon ID',
            'Beacon Name',
            'จำนวนผู้ใช้ที่ได้รับ',
            'Line Friend',
            'Non-Line Friend',
            'จำนวนข้อความทั้งหมด'
          ]
        ]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `beacon-user-messages.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/ReportMessageList.vue